import { Archive, Loader2 } from "lucide-react";
import { useState, type FormEvent } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { useTheme } from "../components/Layout";
import { Banner } from "../components/ui";
import { useAuth } from "../services/auth";
import { t } from "../i18n";

export default function Login() {
  useTheme();
  const { state, login, recheck } = useAuth();
  const nav = useNavigate();
  const location = useLocation();
  const [username, setUsername] = useState("admin");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  const from = (location.state as any)?.from || "/";

  if (state.status === "authenticated") return <Navigate to={from} replace />;

  async function submit(e: FormEvent) {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await login(username, password);
      nav(from, { replace: true });
    } catch (err: any) {
      setError(err?.message || t("Sign-in failed"));
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-gradient-to-b from-slate-50 to-slate-100 p-4 dark:from-slate-950 dark:to-slate-900">
      <div className="w-full max-w-sm">
        <div className="mb-6 flex flex-col items-center text-center">
          <div className="mb-3 rounded-xl bg-brand-600 p-2.5 text-white shadow-sm"><Archive className="h-6 w-6" /></div>
          <h1 className="text-xl font-semibold">DomainOps Hub</h1>
          <p className="mt-1 text-sm text-slate-500">{t("Sign in to continue")}</p>
        </div>
        <form onSubmit={submit} className="card-pad space-y-4">
          {state.status === "api_error" && (
            <Banner tone="warning" action={<button type="button" className="btn-secondary btn-sm" onClick={recheck}>{t("Retry")}</button>}>{t("Server unreachable: {message}", { message: state.message })}</Banner>
          )}
          <div>
            <label className="label" htmlFor="u">{t("Username")}</label>
            <input id="u" className="input" autoComplete="username" value={username} onChange={(e) => setUsername(e.target.value)} />
          </div>
          <div>
            <label className="label" htmlFor="p">{t("Password")}</label>
            <input id="p" className="input" type="password" autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} autoFocus />
          </div>
          {error && <p className="text-sm text-red-600" role="alert">{error}</p>}
          <button className="btn-primary w-full" disabled={busy || !password}>
            {busy && <Loader2 className="h-4 w-4 animate-spin" />} {t("Sign in")}
          </button>
        </form>
      </div>
    </div>
  );
}
